// VAT_PERCENTAGES is a map of country codes to VAT percentages
// Each country in this object has resident-only VAT rates
const VAT_PERCENTAGES: Record<string, number> = {
  AR: 21,
  CL: 19,
  CO: 19,
  IL: 18,
  PE: 18
}

// VAT_EXEMPT_PLACE_IDS is an array of place IDs that are exempt from VAT (e.g. Eilat city in Israel)
const VAT_EXEMPT_PLACE_IDS = ['143']

// Get the resident-only VAT rate for a given country code
export const getResidentVatRate = (countryCode: string) => {
  return VAT_PERCENTAGES[countryCode] || 0
}

// Check if the given country has resident-only VAT rates and the place ID is not exempt from VAT
export const hasResidentOnlyVAT = (countryCode?: string, placeId?: string) => {
  if (!countryCode || !placeId) return false

  return (
    Object.keys(VAT_PERCENTAGES).includes(countryCode) &&
    !VAT_EXEMPT_PLACE_IDS.includes(placeId)
  )
}

// For only IL, we need to display "Additional charges may apply" for price compliance requirements
export const getHasILResidentVAT = (countryCode?: string, cityId?: string) => {
  if (!countryCode || !cityId) return false

  return countryCode === 'IL' && !VAT_EXEMPT_PLACE_IDS.includes(cityId)
}
